import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const NavigationCommunitiesBoundary = () =>
  import(/* webpackChunkName: "4-feat-navigationcommunities" */ './NavigationCommunitiesBoundary');

const LoadableNavigationCommunities: ComponentType = lazyLoadOnRender({ loader: NavigationCommunitiesBoundary });

export default LoadableNavigationCommunities;
